<template>
  <div>
    <a-input-search
      v-model="textVals"
      :placeholder="language['column.pleaseChoose'] + language['common.agentButton'] + language['system.user.name']"
      readOnly
      unselectable="on"
      :disabled="disabled"
      @search="onSearchDepUser"
    >
      <a-button slot="enterButton" :disabled="disabled">{{
        language['column.pleaseChoose'] + language['user']
      }}</a-button>
    </a-input-search>
    <j-select-user-by-dep-and-application-modal
      ref="selectModal"
      :modal-width="modalWidth"
      :application-code="applicationCode"
      :multi="multi"
      @ok="selectOK"
      :user-ids="value"
      :store="storeField"
      :text="textField"
      @initComp="initComp"
      :factory="factory"
    />
  </div>
</template>

<script>
import JSelectUserByDepAndApplicationModal from './modal/JSelectUserByDepAndApplicationModal'
import { underLinetoHump } from '@/components/_util/StringUtil'

export default {
  name: 'JSelectUserByDepAndApplication',
  components: { JSelectUserByDepAndApplicationModal },
  props: {
    modalWidth: {
      type: Number,
      default: 1250,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    multi: {
      type: Boolean,
      default: true,
      required: false,
    },
    applicationCode: {
      type: String,
      default: null,
      required: true,
    },
    backUser: {
      type: Boolean,
      default: false,
      required: false,
    },
    // 存储字段 [key field]
    store: {
      type: String,
      default: 'username',
      required: false,
    },
    // 显示字段 [label field]
    text: {
      type: String,
      default: 'realname',
      required: false,
    },
    factory: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      storeVals: '', //[key values]
      textVals: '', //[label values]
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    storeField() {
      let field = this.customReturnField
      if (!field) {
        field = this.store
      }
      return underLinetoHump(field)
    },
    textField() {
      return underLinetoHump(this.text)
    },
  },
  mounted() {
    this.storeVals = this.value
  },
  watch: {
    value(val) {
      this.storeVals = val
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  methods: {
    initComp(textVals) {
      this.textVals = textVals
    },
    //返回选中的用户信息
    backDeparInfo() {
      if (this.backUser === true) {
        if (this.storeVals && this.storeVals.length > 0) {
          let arr1 = this.storeVals.split(',')
          let arr2 = this.textVals.split(',')
          let info = []
          for (let i = 0; i < arr1.length; i++) {
            info.push({
              value: arr1[i],
              text: arr2[i],
            })
          }
          this.$emit('back', info)
        }
      }
    },
    onSearchDepUser() {
      this.$refs.selectModal.showModal()
    },
    selectOK(rows) {
      console.log('当前选中用户', rows)
      if (!rows) {
        this.storeVals = ''
        this.textVals = ''
      } else {
        let temp1 = []
        let temp2 = []
        for (let item of rows) {
          temp1.push(item[this.storeField])
          temp2.push(item[this.textField])
        }
        this.storeVals = temp1.join(',')
        this.textVals = temp2.join(',')
      }
      this.$emit('change', this.storeVals)
    },
  },
}
</script>

<style scoped>
</style>